// @TODO should this reducer be merged back into the PrequalForm reducer using hidden fields for state?
export const verification_statuses = {
    UNKNOWN: 'UNKNOWN',
    VERIFIED: 'VERIFIED',
    UNVERIFIED: 'UNVERIFIED',
    ERROR: 'ERROR'
};

export const initialState = {
    street: '',
    zip: '',
    secondary: '',
    city: '',
    state: '',
    is_secondary_suggested: false,
    is_verifying: false,
    verification_status: verification_statuses.UNKNOWN, // @TODO maybe 3-way enum? unknown, yes, no
};

export default function address (state = initialState, action) {
    switch(action.type) {
        case '@@redux-form/CHANGE':
            // have to check for action.payload here since it might be null or ""
            // stupid complex conditional
            // if the affected field is street, and it's been changed (to null or not null) 
            // but isn't a change from a suggestion selection
            /*
            if(action.meta.field == 'street' && (!action.payload || (action.payload && !action.payload.suggestSelect))) {
                return {
                    ...state,
                    is_verified
                }
            }
            */

            switch(action.meta.field) {
                case 'street':
                    // duplicated from PrequalForm reducer
                    if(action.payload && action.payload.suggestSelect) {
                        let address_components = action.payload.gmaps.address_components.reduce((carry, component) => {
                            if (component.types[0] == 'locality') {
                                carry[component.types[0]] = component.long_name;
                            } else {
                                carry[component.types[0]] = component.short_name;
                            }
                            return carry;
                        }, {});
                        return {
                            ...state,
                            street: [address_components.street_number, address_components.route].join(' '),
                            city: address_components.locality,
                            state: address_components.administrative_area_level_1,
                            zip: [
                                    address_components.postal_code, 
                                    address_components.postal_code_suffix
                                ].filter((e) => (e != null))
                                .join('-'),
                            verification_status: verification_statuses.UNKNOWN,
                            is_secondary_suggested: false
                        }
                    } else {
                        return {
                            ...state,
                            street: action.payload,
                            verification_status: verification_statuses.UNKNOWN,
                            is_secondary_suggested: false
                        }
                    }
                case 'zip':
                    return {
                        ...state,
                        zip: action.payload,
                        verification_status: verification_statuses.UNKNOWN
                    }   
                case 'secondary':
                    return {
                        ...state,
                        secondary: action.payload
                        // no need to change verification status for secondary change
                    }
                default: 
                    return state;
            }
        case 'REQUEST_ADDRESS':
            return {
                ...state,
                is_verifying: true,
                is_secondary_suggested: false
            };
        case 'ERROR_REQUESTING_ADDRESS':
            // @TODO is there anything else that needs doing, here?
            return {
                ...state,
                is_verifying: false,
                is_secondary_suggested: false,
                verification_status: verification_statuses.ERROR
            };
            
        case 'RECEIVED_ADDRESS':
            if(action.payload 
                && action.payload.validation_response 
                && action.payload.validation_response.address
                && action.payload.validation_response.request_address
                && action.payload.validation_response.request_address.street == state.street
                && action.payload.validation_response.request_address.zipcode == state.zip
            ) {
                return {
                    ...state,
                    is_secondary_suggested: action.payload.validation_response.is_secondary_suggested,
                    is_verifying: false,
                    verification_status: verification_statuses.VERIFIED
                }
            }
            else {
                return {
                    ...state,
                    is_verifying: false,
                    is_secondary_suggested: false,
                    verification_status: verification_statuses.UNVERIFIED
                }
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/address.js